import React, { useRef, useState, useContext } from "react";
import styled, {ThemeContext} from "styled-components";
import Journey from "@airasia/phoenix-widgets/widgets/Journey";
import HotelCardV2 from '@airasia/phoenix-widgets/widgets/HotelCard';
import _ from "lodash";
import Slider from "react-slick";
import {Icon, Typography, useTheme, withWidth} from "@material-ui/core"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import flight_soldout from "../../../images/flight_soldout.svg";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { getJourneyHelper } from "../../Journey/helper";
import { getAirAsiaPrioritised, getAirAsiaPrioritisedNew, fireGtmEvent } from "../../../utils/function";
import { IndeterminateCheckBox, OpenInNew as OpenInNewIcon } from "@material-ui/icons";
import { hotelSampleData, testDataFromresp, transformRespToProps } from "../../../testData/hotels";


var StyledFaChevronRight = styled(FaChevronRight)`
  position: absolute;
  top: 0;
  z-index: 2;
  right: -20px;
  background-color: white;
  height: 100%;
  color: ${({ theme }) => theme.colors['secondary']};
  @media screen and (max-width: 1020px) {
    right: 0px;
  }
`
var StyledFaChevronLeft = styled(FaChevronLeft)`
  position: absolute;
  top: 0;
  z-index: 2;
  left: -20px;
  background-color: white;
  height: 100%;
  color: ${({ theme }) => theme.colors['secondary']};
  @media screen and (max-width: 1020px) {
    left: 0px;
  }
`

const PanelWrapper = styled.div`
    // border: 1px solid blue;
    // display: flex;
    // overflow-x: auto;
    // width: 700px;
    margin-top: 16px;
    .slick-list{
        padding-inline: 0px !important;
    }
    .slick-track{
        // width: auto !important;
    }

    .slick-track .slick-slide{
        box-sizing: border-box;
        // width: auto !important;
    }
    .slick-track .slick-slide:first-child{
        padding-right: 8px;
        padding-left: 4px;
        // border: 1px solid red;
    }
    .slick-track .slick-slide:not(:first-child):not(:last-child){
        padding-left: 8px;
        padding-right: 8px;
        // border: 1px solid green;
    }
    .slick-track .slick-slide:last-child{
        padding-left: 8px;
        // border: 1px solid blue;
    }
`;

const CardWrapper = styled.div`
    // border: 4px solid black;
    height: ${props => props?.isHeighterCard ? "400px" : "250px"};
    min-width: 300px;
    max-width: 600px;
    padding-block: 4px;
    width: ${props => `${props.panelWidth}px` || '123px'};
    flex-shrink: 0;
    // border-radius: 32px;
    & [class^=Container__StyledContainer]{
        border-radius: 32px;
    }
`;

const getCardWrapperWidth = (panelRef, dividedBy = 3) => {
    if (_.isEmpty(panelRef)) {
        return 300
    } else {
        const dividedByFinal = isNaN(dividedBy) ? panelRef.clientWidth : dividedBy;
        return Math.floor((panelRef.clientWidth / dividedByFinal) - 8)
    }
}

function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return <StyledFaChevronRight onClick={onClick} />
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return <StyledFaChevronLeft onClick={onClick} />
}

const TabPanel = ({isHotels=false, width, selectFlightLink='', viewMoreHotelsLink='https://www.airasia.com', viewMoreFlightsLink='https://www.airasia.com', data=[], isLoading = false, flightDataKeys={}, searchType='bundled', sortBy='cheapest', title=''}) => {

    const panelWrapperRef = useRef();
    const muiTheme = useTheme();
    const airAsiaTheme = useContext(ThemeContext);

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        // centerMode: true,
        // centerPadding: "100px",
        // className: "center",
        responsive: [
            {
                breakpoint: muiTheme.breakpoints.values["sm"],
                settings: {
                    slidesToShow: 1,
                    nextArrow: <SampleNextArrow />,
                    prevArrow: <SamplePrevArrow />,
                }
            },
            {
                breakpoint: muiTheme.breakpoints.values["md"],
                settings: {
                    slidesToShow: 2,
                    nextArrow: <SampleNextArrow />,
                    prevArrow: <SamplePrevArrow />,
                }
            }
        ]
    };

    const [isMobile] = useState(['xs', 'sm'].includes(width));

    const getDummyCards = (len, isLoading) => {
        let balance = isLoading ? len : 3 - len;
        let arr = [];
        while(balance >= 0){
            arr.push(<CardWrapper panelWidth={getCardWrapperWidth(panelWrapperRef.current, isMobile ? null : 3)}>{isLoading ? 
                <div style={{display: "flex", width: "100%", flexShrink: 0, height: 250 }}>
                  <Skeleton height={250} containerClassName="skeletonContainerClass" />
                </div>
                : null}</CardWrapper>)
            balance--;
        }
        return arr
    }

    const getFastestFlights = (flightsList, key="flightDetails.duration", alternateKey="flightDetails.duration.total") => {
        let temp = flightsList.reduce((acc,x)=>{
            x.travelTime = _.get(x, key)
            if(!_.isNumber(x.travelTime)){
                x.travelTime = _.get(x, alternateKey)
            }
            acc.push(x);
            console.log('----------------------------------------------', x.travelTime, _.get(x, key), _.get(x, alternateKey))
            return acc
        }, []);
        temp = _.sortBy(flightsList, 'travelTime');
        return temp
        return _.take(temp, 10);
    };

    const getCheapestFlights = (flightsList, key="convertedPrice") => {
        let temp = _.cloneDeep(flightsList)
        temp = _.sortBy(flightsList, key);
        return temp
        // return _.take(temp, 10);
    };

    const getDirectFlights = (flightsList, key="flightDetails.numberOfStops") => {
        let temp = _.filter(flightsList, x => _.get(x, key)===0);
        return _.take(temp, 10);
    };

    const sorter = (flightsList, sortKey='cheapest') => {
        switch(sortKey){
            case 'fastest':{
                return getFastestFlights(flightsList)
            }
            case 'direct': {
                return getDirectFlights(flightsList)
            }
            default: {
                // cheap_flightsOnView(flightsList);
                return getCheapestFlights(flightsList)
            }
        }
    };

    const flightsData = isHotels ? [] : getAirAsiaPrioritisedNew(sorter(_.get(data, _.get(flightDataKeys, `${searchType}.flightsList`), []), sortBy), _.get(data, _.get(flightDataKeys, `${searchType}.carriers`), {}));
    const hotelsData = isHotels ? data : [];
    const carrierList = _.get(data, _.get(flightDataKeys, `${searchType}.carriers`))
    const firingFlightsGTMOnView = (type,journey = {}, title) => {
        const gtmEvent = {
            event: type,
            "ecommerce": {
                currencyCode: journey?journey[0].userCurrencyCode:"",
                impressions: journey.map((x, index) => {
                let getFlightDepatureDate = dateStrToDateSlashStr(x?.flightDetails?.designator?.departureTime)
                    console.log('----------------------------------------------', x.flightDetails)
                    return {
                        id: x.tripId,
                        name: x.flightDetails?.designator?.departureStation+"-"+x.flightDetails?.designator?.arrivalStation, //'CEB-PPS'
                        price: x.price, 
                        brand: _.get(carrierList, _.get(flightDataKeys, searchType+'.segments', '')), // carrierList[x.flightDetails?.segments[0]?.airline], //OTA flights 
                        category: 'Air Tickets',
                        variant: '',
                        position: index,
                        dimension1: 'OW',
                        dimension2: x.flightDetails?.designator?.departureStation, //'CEB'
                        dimension3: x.flightDetails?.designator?.arrivalStation, //'PPS'
                        dimension4: 'Z',
                        dimension5: getFlightDepatureDate, //'2023-05-07'
                        dimension6: 'Flight 1',
                        dimension8: title === "Next Month"?30:7,//7,
                        dimension9: 1,//1,
                        dimension10: 1,//1,
                        dimension13: x.flightDetails?.designator?.departureStation+"-"+x.flightDetails?.designator?.arrivalStation,//'CEB-PPS'
                        dimension15: x.flightDetails?.numberOfStops==0?'Direct':'Transit',
                        dimension16: _.get(x, _.get(flightDataKeys, searchType+'.airline', ''), '')+_.get(x, _.get(flightDataKeys, searchType+'.marketingFlightNo', ''), ''),//'AK6142',
                        dimension42: '', //international
                        dimension61: x?.flightDetails?.duration,
                        list: title?sortBy+" flights|"+title:sortBy+" flights"
                    }
                  })
                
            }
        }
        // console.log("journeyOnView",journey)
        fireGtmEvent(gtmEvent)
    
    }

    var [isHotelsImpressions, setIsHotelsImpressions] = useState(false)

    const renderCards = () => {
        if(isHotels){
            if(!isHotelsImpressions){
                firingHotelsGTMonView("productImpressions",hotelsData, "Hotel recommendation|route page")
                setIsHotelsImpressions(true)
            }
            return hotelsData.map((datum, idx) => <CardWrapper key={`hotel-card-${idx}`} isHeighterCard panelWidth={getCardWrapperWidth(panelWrapperRef.current, isMobile ? null : 5)} style={{height: 400}}><HotelCard datum={transformRespToProps(datum)} isMobile={isMobile} position={idx}/></CardWrapper>);
        }
        else{
            if(flightsData.length){
                firingFlightsGTMOnView("productImpressions",flightsData, title)
                return flightsData?.map((datum, idx) => (
                    <CardWrapper key={`flight-card-${idx}`} panelWidth={getCardWrapperWidth(panelWrapperRef.current, isMobile ? null : 3)}>
                        <DummyJourneyCard selectFlightLink={selectFlightLink} journey={datum} data={data} isMobile={isMobile} idx={idx} flightDataKeys={flightDataKeys} searchType={searchType} sortBy={sortBy} carrierList={carrierList} title={title}/>
                    </CardWrapper>
                ))
            }
        }
    }

    return (
        <PanelWrapper ref={panelWrapperRef}>
            <Slider {...settings}>
                {
                    isLoading 
                    ?   getDummyCards(3, isLoading)
                    :   renderCards()
                }
                {
                    (flightsData.length > 1 || (isHotels && hotelsData.length > 1)) && !isLoading
                        ?
                        <CardWrapper panelWidth={getCardWrapperWidth(panelWrapperRef.current, 3)}>
                            <a href={isHotels ? viewMoreHotelsLink : viewMoreFlightsLink} target='_blank' style={{ width: "99%", height: "75%", alignItems: "center", display: "flex", justifyContent: "center", background: _.get(airAsiaTheme, 'colors.primary')+"1f", border: "1px solid "+_.get(airAsiaTheme, 'colors.primary'), borderRadius: "32px" }}>
                                <Typography variant='subtitle1' style={{ textAlign: 'center', color: _.get(airAsiaTheme, 'colors.secondary'), textDecoration: 'underline' }}>View all {isHotels ? "hotels" : "flights"} </Typography>
                                <OpenInNewIcon style={{ fontSize: "16px", color: _.get(airAsiaTheme, 'colors.secondary') }} />
                            </a>
                        </CardWrapper>
                        : null
                }
                {
                    (((!isHotels && _.isEmpty(flightsData)) || (isHotels && _.isEmpty(hotelsData))) && !isLoading) 
                    ?   [
                            isMobile ? null : <CardWrapper panelWidth={getCardWrapperWidth(panelWrapperRef.current, 3)} />,
                            <CardWrapper panelWidth={getCardWrapperWidth(panelWrapperRef.current, 3)}>
                                <div style={{width: "100%", display: "flex", justifyContent: "center"}}><img src={flight_soldout} alt={isHotels ? "No Hotels Found" : "No flights found"}/></div>
                                <a href={isHotels ? viewMoreHotelsLink : viewMoreFlightsLink} target='_blank'>
                                    <Typography variant='subtitle1' style={{textAlign: 'center', color: _.get(airAsiaTheme, 'colors.secondary'), textDecoration: 'underline'}}>View more {isHotels ? "hotels" : "flights"} in our search page</Typography>
                                </a>
                            </CardWrapper>,
                            isMobile ? null : <CardWrapper panelWidth={getCardWrapperWidth(panelWrapperRef.current, 3)} />
                        ]
                    :   (!isMobile && !isLoading) && (-1 < flightsData?.length < 3) && getDummyCards(flightsData?.length || 3)
                }
            </Slider>
        </PanelWrapper>
    )
}

export default withWidth()(TabPanel);

const HotelCard = ({datum={}, isMobile=false, position=0}) => {
    let data = [datum]
    return(
        // <HotelCardV2 {...datum} isMobile onClick={()=>openHotelsPageInNewTab(datum)} />
        <HotelCardV2 {...datum} isMobile onClick={()=>{openHotelsPageInNewTab(datum);firingHotelsGTMonClick("productClick",data,position)}} />
        
    )
};

const DummyJourneyCard = ({journey={}, isMobile=true, data={}, idx, flightDataKeys={}, searchType='bundled', selectFlightLink='', sortBy, carrierList, title}) => {
    let journeys = getJourneyHelper(_.get(data, _.get(flightDataKeys, `${searchType}.searchResults`)), journey, idx, _.get(data, _.get(flightDataKeys, `${searchType}.content`)), searchType, _.get(data, _.get(flightDataKeys, `${searchType}.airlineProfile`)))
    // console.log('journeys --- ', journeys)
    return (
        <Journey
            accessible
            hourCycle={24}
            baggageDataList={[]}
            carrierSize="small"
            ctaPosition="center"
            ctaShowButton
            customDetailText={null}
            // customEvent={() => openFlightsPageInNewTab(journey)}
            customGuestText={null}
            customProperties={{
                'aria-label': 'this is an a11y custom label',
                id: 'customPropsID'
            }}
            defaultDisabledFeatures={false}
            disabled={false}
            guest={1}
            handleClick={()=>{openFlightsPageInNewTab(journey, selectFlightLink);firingFlightsGTMOnClick("productClick",journey,sortBy, carrierList, title, idx, flightDataKeys, searchType)}}
            // handleViewClick={(e)=>console.log("from handleViewClick --- ", e)}
            hasBoxShadow
            hasNoCheckedBaggage={false}
            hasNoCheckedBaggageOnly={false}
            hasPadding
            isBestDeal={false}
            isMobile={true}
            isMobileStyleInDesktop
            isSelected={false}
            journeyDetailsJourneys={[]}
            journeyDetailsTranslation={{
                journeyHeaderBestReturn: "Best returning flights",
                operatedBy: "Operated by",
                subjectToGovtApproval: "Flight is subject to obtaining government approval",
                journeyHeaderBestDepart: "Best departing flights",
                journeyHeaderOtherReturn: "Other returning flights",
                journeyHeaderRoundtrip: "Departing and returning flights",
                journeyHeaderOtherDepart: "Other departing flights",
                journeyHeaderReturn: "Returning flights",
                infantMessage: "*We’ll add an infant fee to the fare at the next page. This applies to AirAsia flights only.",
                journeyHeaderOneway: "Departing flights"
            }}
            journeys={journeys}
            // journeys={getJourneyHelper(_.get(data, _.get(flightDataKeys, `${searchType}.searchResults`)), journey, idx, _.get(data, _.get(flightDataKeys, `${searchType}.content`)), searchType, _.get(data, _.get(flightDataKeys, `${searchType}.airlineProfile`)))}
            // journeys={[{...journey, ..._.get(journey, "flightDetails", []), numberOfStops: _.get(journey, "flightDetails.numberOfStops.total", 0), duration: _.get(journey, "flightDetails.duration.total", 0), segments: _.get(journey, "flightDetails.segments")}]}
            loading={false}
            locale={_.get(data, "locale.userLocale", "en-gb")}
            price={{
                amount: journey.convertedPrice,
                currency: _.get(journey, "userCurrencyCode", "")
            }}
            showBaggageAllowance={false}
            showBundleType={false}
            showFlightDetails={false}
            stopoverSize={isMobile ? "small" : "medium"}
            theme="AIRASIA_MOVE"
            translation={getTranslation(_.get(data, "locale.translation", {}), _.get(data, "locale.userLocale", "en-gb"))}
            tripType="oneway"
            useLocalTimezone={true}
            tagsList={[
                {
                  "title": new Date(_.get(journey, "flightDetails.designator.departureTimeUtc")).toLocaleDateString(_.get(data, "locale.userLocale", "en-gb")),
                  "redirectLink": "",
                  "color": "blueLight",
                  "hasIcon": false,
                  "icon": "",
                  "iconColor": ""
                }
              ]}
        />
    )
}

const getTranslation = (translationObject={}, lang) => {
    return {
        vtlLabel: _.get(translationObject, "keywords.vtlMessage", ""),
        stopAt: _.get(translationObject, "listing.stopAt", ""),
        hour: _.get(translationObject, "listing.hours", ""),
        minute: _.get(translationObject, "listing.minutes", ""),
        depart: _.get(translationObject, "listing.depart", ""),
        return: _.get(translationObject, "listing.return", ""),
        nonStop: _.get(translationObject, "listing.noStops", ""),
        singleStop: _.get(translationObject, "listing.oneStop", "").replace('{0}', '1'),
        multiStop: _.get(translationObject, "listing.multipleStops", "").replace('{0}', '{stop}'),
        ctaText: _.get(ctaTextTranslations, lang, ""),
        guest: _.get(translationObject, "listing.forOneGuest", "").replace('{0}', '1'),
        details: _.get(translationObject, "listing.flightDetailsCTA", ""),
        perGuest: _.get(translationObject, "listing.perGuest", ""),
        subjectToGovtApproval: _.get(translationObject, "journey.subjectToGovtApproval", "")
    };
}

const ctaTextTranslations = {
    "en-gb": "View More",
    "th-th": "ดูเพิ่มเติม",
    "id-id": "Melihat lebih banyak",
    "ms-my": "Lihat lebih banyak",
    "ko-kr": "더보기",
    "ja-jp": "もっと見る",
    "vi-vn": "Xem thêm",
    "zh-tw": "查看更多",
    "zh-hk": "查看更多",
    "zh-cn": "查看更多",
    "tr-tr": "daha fazla göster"
};

const dateStrToDateSlashStr = (dateStr) => new Date(dateStr).toISOString().split("T")[0].split("-").reverse().join("/");

const openFlightsPageInNewTab = (journey = {}) => {
    console.log("GATSBY_ENV ---- ", process.env.GATSBY_ENV);
    const navBasepath = process.env.GATSBY_ENV === "dev" ? "https://www.devairasia.com" : process.env.GATSBY_ENV === "stg" ? "https://www.stgairasia.com" : "https://www.airasia.com";
    if(typeof window !== "undefined"){
        let a = document.createElement("a");
        a.target = "_blank";
        
        a.href = `${navBasepath}/flights/search/?origin=${journey?.flightDetails?.designator?.departureStation}&destination=${journey?.flightDetails?.designator?.arrivalStation}&departDate=${dateStrToDateSlashStr(journey?.flightDetails?.designator?.departureTime)}&tripType=O&adult=1&child=0&infant=0&locale=${journey?.locale?.userLocale}&currency=${journey?.userCurrencyCode}&ule=true&cabinClass=economy&uce=false&promoCode=&type=paired&airlineProfile=all&upsellWidget=true`;
        a.click()
    }
}

const openHotelsPageInNewTab = (hotelObj = {}) => {
    console.log("GATSBY_ENV ---- ", process.env.GATSBY_ENV);
    // https://www.airasia.com/hotel/search/index.html?F_R=&aaId=&adults=1&amenity=&applyBigpoints=false&countryCode=MY&currency=MYR&days=3&destination=178308&fromDate=2023-04-26&languageId=en-gb&rooms=1&sort=Hotel%20Search%20Results%20-%20Recommendation&toDate=2023-04-29
    const navBasepath = process.env.GATSBY_ENV === "dev" ? "https://www.devairasia.com" : process.env.GATSBY_ENV === "stg" ? "https://www.stgairasia.com" : "https://www.airasia.com";
    if(typeof window !== "undefined"){
        let a = document.createElement("a");
        a.target = "_blank";
        
        a.href = `${navBasepath}/hotel/search/index.html?F_R=&aaId=${_.get(hotelObj, 'debugObj.aaid', '')}&adults=1&amenity=&applyBigpoints=false&countryCode=${_.get(hotelObj, 'countryCode', 'MY')}&currency=${_.get(hotelObj, 'currency', 'MYR')}&days=3&destination=${_.get(hotelObj, 'locationId', '18008')}&fromDate=${_.get(hotelObj, 'startDate', '')}&languageId=${_.get(hotelObj, 'lang', 'en-gb')}&rooms=1&sort=Hotel%20Search%20Results%20-%20Recommendation&toDate=${_.get(hotelObj, 'endDate', '')}`;
        a.click()
    }
}

const openFlightCheckoutPageInNewTab = (journey = {}, selectFlightLink='') => {
    console.log("GATSBY_ENV ---- ", process.env.GATSBY_ENV);
    const navBasepath = process.env.GATSBY_ENV === "dev" ? "https://www.devairasia.com" : process.env.GATSBY_ENV === "stg" ? "https://www.stgairasia.com" : "https://www.airasia.com";
    if(typeof window !== "undefined"){
        let a = document.createElement("a");
        a.target = "_blank";
        a.href = selectFlightLink.replace('{tripId}', _.get(journey, "tripId")) //  `${navBasepath}/checkout/search/?origin=${journey?.flightDetails?.designator?.departureStation}&destination=${journey?.flightDetails?.designator?.arrivalStation}&departDate=${dateStrToDateSlashStr(journey?.flightDetails?.designator?.departureTime)}&tripType=O&adult=1&child=0&infant=0&locale=${journey?.locale?.userLocale}&currency=${journey?.userCurrencyCode}&ule=true&cabinClass=economy&uce=false&promoCode=&type=bundled&airlineProfile=all&upsellWidget=true`;
        // a.href = `${navBasepath}/flights/search/?origin=${journey?.flightDetails?.designator?.departureStation}&destination=${journey?.flightDetails?.designator?.arrivalStation}&departDate=${dateStrToDateSlashStr(journey?.flightDetails?.designator?.departureTime)}&tripType=O&adult=1&child=0&infant=0&locale=${journey?.locale?.userLocale}&currency=${journey?.userCurrencyCode}&ule=true&cabinClass=economy&uce=false&promoCode=&type=bundled&airlineProfile=all&upsellWidget=true`;
        console.log(a.href);
        a.click()
    }
}

const firingFlightsGTMOnClick = (type,journey = {}, sortBy, carrierList, title, position, flightDataKeys, searchType) => {
    const gtmEvent = {
        event: type,
        "ecommerce": {
            currencyCode: journey?.userCurrencyCode,
            click: {
                actionField: {list: title?sortBy+" flights|"+title:sortBy+" flights"},
                products: [{
                    id: journey.tripId,
                    name: journey?.flightDetails?.designator?.departureStation+"-"+journey?.flightDetails?.designator?.arrivalStation, //'CEB-PPS'
                    price: journey.price, 
                    brand: carrierList?carrierList[_.get(journey, _.get(flightDataKeys, searchType+'.airline'))]:_.get(journey, _.get(flightDataKeys, searchType+'.airline')), //OTA flights 
                    category: 'Air Tickets',
                    variant: '',
                    position: position,
                    dimension1: 'OW',
                    dimension2: journey.flightDetails?.designator?.departureStation,
                    dimension3: journey.flightDetails?.designator?.arrivalStation,
                    dimension4: '',
                    dimension5: dateStrToDateSlashStr(journey?.flightDetails?.designator?.departureTime), 
                    dimension6: 'Flight 1',
                    dimension8: title === "Next Month"? 30:7,
                    dimension9: 1,
                    dimension10: 1,
                    dimension13: journey.flightDetails?.designator?.departureStation+"-"+journey.flightDetails?.designator?.arrivalStation,
                    dimension15: journey.flightDetails?.numberOfStops==0?'Direct':'Transit',
                    dimension16:  _.get(journey, _.get(flightDataKeys, searchType+'.airline', ''), '')+_.get(journey, _.get(flightDataKeys, searchType+'.marketingFlightNo', ''), ''), //journey.flightDetails?.depart?.segments[0]?.airline+journey.flightDetails?.depart?.segments[0]?.flightNumber,
                    dimension42: '', //international
                    dimension61: journey?.flightDetails?.duration
                }]
            }
        },
        
    }
    fireGtmEvent(gtmEvent)

}

const firingHotelsGTMonView = (type,data = {}, title) => {
    if(data.length){
        const gtmEvent = {
            event: type,
            "ecommerce": {
                currencyCode: data?data[0].currency:"",
                impressions: data.map((x, index) => {
                    return {
                        list: title,
                        id: x.id,
                        name:x.name,
                        price: x?.prices?.rate?.lead_price?.base_rate?.value,
                        brand: 'Hotel SA',
                        category: 'Hotel SA - Hotel',
                        variant: '',
                        position: index,
                        dimension8: '1',
                        dimension9: '1',
                        dimension10: '',
                        dimension71: x?.star_rating?.rating,
                        dimension72: x?.guest_rating?.rating,
                        dimension79: '',
                        dimension103: x?.guest_rating?.count,
                        dimension104: '',
                        dimension110: ''
                        }

                    }
                )
            },
        }
    fireGtmEvent(gtmEvent)
    }

}

const firingHotelsGTMonClick = (type,data = {}, position) => {
    if(data.length){
        const gtmEvent = {
            event: type,
            "ecommerce": {
                currencyCode: data?data[0].currency:"",
                click: {
                    actionField: {list: "Hotel recommendation|route page"},
                    products: data.map((x, index) => {
                
                    return {
                        id: x.id,
                        name:x.name,
                        price: x?.prices?.rate?.lead_price?.base_rate?.value,
                        brand: 'Hotel SA',
                        category: 'Hotel SA - Hotel',
                        variant: '',
                        position: position,
                        dimension8: '1',
                        dimension9: '1',
                        dimension10: '',
                        dimension71: x?.star_rating?.rating,
                        dimension72: x?.guest_rating?.rating,
                        dimension79: '',
                        dimension103: x?.guest_rating?.count,
                        dimension104: '',
                        dimension110: ''
                        }

                    }
                )
            },
            }
        }
    fireGtmEvent(gtmEvent)
    }
}

